import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { AppProject } from '../../../../shared/models/interfaces/app-project.interface'
import { AppReportingPeriodResponse } from '../../../../shared/models/interfaces/app-reporting-period.interface'
import { TranslateModule } from '@ngx-translate/core'
import { AppReportingPeriodTableComponent } from '../../../../shared/components/app-reporting-period-table/app-reporting-period-table.component'
import { ButtonModule } from 'primeng/button'
import { AppBasicInputComponent } from '../../../../shared/components/app-basic-input/app-basic-input.component'
import { AppBasicLoaderComponent } from '../../../../shared/components/app-basic-loader/app-basic-loader.component'
import { CommonModule } from '@angular/common'

@Component({
   selector: 'ep-running-reporting-period',
   templateUrl: './ep-running-reporting-period.component.html',
   standalone: true,
   imports: [CommonModule, AppBasicLoaderComponent, AppBasicInputComponent, ButtonModule, AppReportingPeriodTableComponent, TranslateModule]
})
export class EpRunningReportingPeriodComponent {
   @Input() project?: AppProject | null
   @Input() isLoadingReportingPeriods?: boolean | null
   @Input() reportingPeriodsRes?: AppReportingPeriodResponse | null

   @Input() endMonthFC?: FormControl
   @Input() nextPeriodFC?: FormControl
   @Input() nextStartMonthFC?: FormControl

   @Output() addReportClick = new EventEmitter()
   @Output() deleteReportClick = new EventEmitter()

   getErrorMessage(control?: FormControl): string {
      if (!control) return ''
      if (control.hasError('required')) return 'error_input_required'
      if (control.hasError('min')) return 'error_input_reporting_minNumber'
      if (control.hasError('max')) return 'error_input_reporting_maxNumber'
      return ''
   }
}
